module.exports = __webpack_public_path__ + "static/media/icon_185.04924658.svg";